import { useTranslation } from 'react-i18next';
import { primaryText, secondaryText, cardBg, borderGrey } from '../../../styling/stylingHelper';
import { cn } from '../../../lib/utils';

export default function StaffHomePage() {
  const { t } = useTranslation();
  return (
    <section className={cn('rounded-xl border p-6 sm:p-8', cardBg, borderGrey)}>
      <h1 className={cn('text-xl font-semibold', primaryText)}>{t('nav.homePage')}</h1>
      <p className={cn('mt-3', secondaryText)}>{t('staff.noPagesPlaceholder')}</p>
    </section>
  );
}
